/* Tech Store — Build My PC configurator.
   Each category is a dropdown fed by one of the store's own collections. Liquid
   renders the first 50 products server-side; on load we fetch the collection's
   public products.json (the store's own data, 250 per page) and rebuild the
   dropdown so EVERY product in the collection is listed. The PDF quote stays
   gated behind the lead form, which posts through Shopify's contact form. */
(function () {
  function money(cents) {
    if (window.TechStore && window.TechStore.formatMoney) return window.TechStore.formatMoney(cents);
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function init(root) {
    if (!root || root.dataset.tsBuildInit) return;
    root.dataset.tsBuildInit = '1';

    var cats = Array.prototype.slice.call(root.querySelectorAll('[data-cat]'));
    var summaryEl = root.querySelector('[data-build-summary]');
    var totalEl = root.querySelector('[data-build-total]');
    var storeKey = 'ts-build-' + (root.dataset.sectionId || 'default');

    function selectOf(cat) { return cat.querySelector('[data-cat-select]'); }
    function selectedOpt(cat) {
      var sel = selectOf(cat);
      return sel && sel.selectedOptions.length ? sel.selectedOptions[0] : null;
    }

    /* ---- persistence: survive the contact-form redirect ---- */
    function save() {
      try {
        var picks = cats.map(function (cat) {
          var sel = selectOf(cat);
          return sel ? sel.value : null;
        });
        localStorage.setItem(storeKey, JSON.stringify(picks));
      } catch (e) {}
    }
    function restore() {
      try {
        var picks = JSON.parse(localStorage.getItem(storeKey) || 'null');
        if (!picks) return;
        cats.forEach(function (cat, i) {
          var sel = selectOf(cat);
          if (!sel || picks[i] == null) return;
          var opt = sel.querySelector('option[value="' + String(picks[i]).replace(/"/g, '') + '"]');
          if (opt && !opt.disabled) sel.value = picks[i];
        });
      } catch (e) {}
    }

    function refresh() {
      var total = 0;
      summaryEl.innerHTML = '';
      cats.forEach(function (cat) {
        var opt = selectedOpt(cat);
        var priceLine = cat.querySelector('[data-cat-price]');
        var skipped = !opt || opt.dataset.skip;
        var cents = skipped ? 0 : parseInt(opt.dataset.price, 10) || 0;
        total += cents;
        if (priceLine) priceLine.textContent = skipped ? '' : money(cents);

        var row = document.createElement('div');
        row.style.cssText = 'display:flex;justify-content:space-between;gap:10px;padding:9px 0;border-bottom:1px solid var(--border,#e6e6ea);font-size:13.5px;';
        var l = document.createElement('span');
        l.style.cssText = 'color:var(--muted,#6e6e73);';
        l.textContent = cat.dataset.catLabel || '';
        var v = document.createElement('span');
        v.style.cssText = 'font-weight:600;text-align:right;max-width:62%;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;';
        v.textContent = skipped ? '—' : (opt.dataset.name || '');
        if (skipped) v.style.color = 'var(--muted,#6e6e73)';
        row.appendChild(l); row.appendChild(v);
        summaryEl.appendChild(row);
      });
      totalEl.textContent = money(total);
      return total;
    }

    cats.forEach(function (cat) {
      var sel = selectOf(cat);
      if (sel) sel.addEventListener('change', function () { refresh(); save(); });
    });

    /* ---- hydrate every dropdown with the FULL collection (store data only) ---- */
    function hydrate(cat) {
      var sel = selectOf(cat);
      if (!sel || !sel.dataset.collection) return Promise.resolve();
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var base = rootPath + 'collections/' + sel.dataset.collection + '/products.json';
      var all = [];
      function page(n) {
        return fetch(base + '?limit=250&page=' + n, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (j) {
            var got = (j && j.products) || [];
            all = all.concat(got);
            /* keep paging until a short page; hard stop at 8 pages (2000 products) */
            return got.length === 250 && n < 8 ? page(n + 1) : all;
          });
      }
      return page(1).then(function (products) {
        if (!products.length) return;
        var prev = sel.value;
        var skipOpt = sel.querySelector('option[data-skip]');
        sel.innerHTML = '';
        if (skipOpt) sel.appendChild(skipOpt);
        products.forEach(function (p) {
          var variants = p.variants || [];
          var cents = variants.length
            ? Math.min.apply(null, variants.map(function (v) { return Math.round(parseFloat(v.price) * 100) || 0; }))
            : 0;
          var available = variants.some(function (v) { return v.available !== false; });
          var o = document.createElement('option');
          o.value = String(p.id);
          o.dataset.name = p.title;
          o.dataset.price = String(cents);
          o.dataset.priceStr = money(cents);
          if (!available) o.disabled = true;
          o.textContent = p.title + ' — ' + money(cents) + (available ? '' : ' (sold out)');
          sel.appendChild(o);
        });
        var count = cat.querySelector('[data-cat-count]');
        if (count) count.textContent = products.length + ' option' + (products.length !== 1 ? 's' : '');
        /* restore previous choice; otherwise skip (optional) or first available */
        if (prev && sel.querySelector('option[value="' + prev + '"]:not([disabled])')) sel.value = prev;
        else if (skipOpt) sel.value = '';
        else { var first = sel.querySelector('option:not([disabled])'); if (first) sel.value = first.value; }
      }).catch(function () { /* keep the Liquid-rendered options */ });
    }

    Promise.all(cats.map(hydrate)).then(function () { restore(); refresh(); });

    restore();
    refresh();

    /* ---- spec lines shared by the PDF and the contact email ---- */
    function specLines() {
      return cats.map(function (cat) {
        var opt = selectedOpt(cat);
        var skipped = !opt || opt.dataset.skip;
        return {
          label: cat.dataset.catLabel || '',
          name: skipped ? '— skipped —' : (opt.dataset.name || ''),
          price: skipped ? '' : (opt.dataset.priceStr || '')
        };
      });
    }

    /* ---- lead modal ---- */
    var modal = root.querySelector('[data-build-modal]');
    var pdfBtn = root.querySelector('[data-build-pdf]');
    var form = root.querySelector('form') || document.getElementById('ts-build-lead-form');

    function openModal() { modal.style.display = 'block'; document.body.style.overflow = 'hidden'; }
    function closeModal() { modal.style.display = 'none'; document.body.style.overflow = ''; }

    if (pdfBtn && modal) pdfBtn.addEventListener('click', openModal);
    if (modal) {
      modal.querySelectorAll('[data-build-modal-close]').forEach(function (el) {
        el.addEventListener('click', closeModal);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    }

    /* ---- submit: validate, build the email body, download the PDF, then post ---- */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var name = root.querySelector('[data-lead-name]');
        var email = root.querySelector('[data-lead-email]');
        var phone = root.querySelector('[data-lead-phone]');
        var note = root.querySelector('[data-lead-note]');
        var body = root.querySelector('[data-lead-body]');
        var err = root.querySelector('[data-lead-error]');

        var problems = [];
        if (!name || !name.value.trim()) problems.push('your name');
        if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value || '')) problems.push('a valid email');
        if (!phone || !/^\+?[\d\s\-()]{8,}$/.test(phone.value.trim())) problems.push('a valid WhatsApp number');
        if (problems.length) {
          if (err) { err.textContent = 'Please add ' + problems.join(', ') + '.'; err.style.display = 'block'; }
          return;
        }
        if (err) err.style.display = 'none';

        var total = refresh();
        var lines = specLines().map(function (s) {
          return s.label + ': ' + s.name + (s.price ? ' — ' + s.price : '');
        });
        if (body) {
          body.value = 'CUSTOM PC BUILD REQUEST\n' +
            '------------------------\n' +
            lines.join('\n') +
            '\n------------------------\n' +
            'Total: ' + money(total) +
            '\nWhatsApp: ' + phone.value.trim() +
            (note && note.value ? '\nNotes: ' + note.value : '');
        }
        save();

        /* Generate the PDF (waiting briefly for the library if needed), THEN post
           the lead. The native submit reloads the page with the success banner. */
        var tries = 0;
        (function attempt() {
          if (window.jspdf && window.jspdf.jsPDF) {
            downloadPDF(root, specLines(), total, name.value.trim(), phone.value.trim(), function () {
              setTimeout(function () { form.submit(); }, 250);
            });
          } else if (tries++ < 20) {
            setTimeout(attempt, 150); /* wait up to ~3s for jspdf to load */
          } else {
            if (err) { err.textContent = 'Preparing your PDF… submitting your request.'; err.style.display = 'block'; }
            setTimeout(function () { form.submit(); }, 250);
          }
        })();
      });
    }
  }

  /* Loads the theme's Brand logo (if set) and hands a PNG data-URL to render().
     The Shopify CDN sends CORS headers, so canvas conversion is safe; on any
     failure or after 2.5s we render without the logo. done() ALWAYS runs. */
  function downloadPDF(root, lines, totalCents, customerName, whatsapp, done) {
    var finished = false;
    function finish() { if (!finished) { finished = true; if (done) done(); } }
    var jspdf = window.jspdf;
    if (!jspdf || !jspdf.jsPDF) { finish(); return; }

    var logoUrl = root.dataset.pdfLogo;
    if (logoUrl) {
      var img = new Image();
      var timer = setTimeout(function () { img.onload = img.onerror = null; render(null); }, 2500);
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        clearTimeout(timer);
        try {
          var c = document.createElement('canvas');
          c.width = img.naturalWidth; c.height = img.naturalHeight;
          c.getContext('2d').drawImage(img, 0, 0);
          render({ data: c.toDataURL('image/png'), w: img.naturalWidth, h: img.naturalHeight });
        } catch (e) { render(null); }
      };
      img.onerror = function () { clearTimeout(timer); render(null); };
      img.src = logoUrl;
    } else {
      render(null);
    }

    function render(logo) {
      try { renderPDF(root, lines, totalCents, customerName, whatsapp, logo); } catch (e) {}
      finish();
    }
  }

  function renderPDF(root, lines, totalCents, customerName, whatsapp, logo) {
    var jspdf = window.jspdf;
    var doc = new jspdf.jsPDF({ unit: 'pt', format: 'a4' });
    var purple = [109, 40, 217], ink = [17, 17, 19], grey = [110, 110, 115];

    doc.setFillColor(13, 13, 16); doc.rect(0, 0, 595, 110, 'F');
    if (logo) {
      /* logo on a white chip, vertically centered at the right of the header,
         so dark logos stay visible on the dark band */
      var maxW = 150, maxH = 34;
      var ratio = logo.w && logo.h ? logo.w / logo.h : 3;
      var lh = maxH, lw = lh * ratio;
      if (lw > maxW) { lw = maxW; lh = lw / ratio; }
      var chipW = lw + 24, chipH = lh + 16;
      var chipX = 555 - chipW, chipY = (110 - chipH) / 2;
      doc.setFillColor(255, 255, 255);
      doc.roundedRect(chipX, chipY, chipW, chipH, 8, 8, 'F');
      doc.addImage(logo.data, 'PNG', chipX + 12, chipY + 8, lw, lh);
    }
    doc.setTextColor(167, 139, 250); doc.setFont('helvetica', 'bold'); doc.setFontSize(11);
    doc.text(root.dataset.pdfBrand || 'CUSTOM PC QUOTE', 40, 50);
    doc.setTextColor(255, 255, 255); doc.setFontSize(22);
    doc.text(root.dataset.pdfTitle || 'Your custom build', 40, 82);

    var y = 140;
    if (customerName) {
      doc.setTextColor.apply(doc, grey); doc.setFont('helvetica', 'normal'); doc.setFontSize(10.5);
      doc.text('Prepared for ' + customerName + (whatsapp ? '  ·  WhatsApp ' + whatsapp : ''), 40, y); y += 24;
    } else { y += 10; }

    doc.setTextColor.apply(doc, ink); doc.setFontSize(13); doc.setFont('helvetica', 'bold');
    doc.text('Configuration', 40, y); y += 10;
    doc.setDrawColor(230, 230, 234); doc.line(40, y, 555, y); y += 24;
    doc.setFontSize(11);

    lines.forEach(function (s) {
      doc.setFont('helvetica', 'normal'); doc.setTextColor.apply(doc, grey);
      doc.text(s.label, 40, y);
      doc.setFont('helvetica', 'bold'); doc.setTextColor.apply(doc, ink);
      var nm = s.name.length > 40 ? s.name.slice(0, 39) + '…' : s.name;
      doc.text(nm, 280, y);
      if (s.price) doc.text(s.price, 555, y, { align: 'right' });
      y += 26;
      doc.setDrawColor(238, 238, 241); doc.line(40, y - 12, 555, y - 12);
      if (y > 760) { doc.addPage(); y = 60; }
    });

    y += 6;
    doc.setFillColor(244, 244, 246); doc.roundedRect(40, y, 515, 54, 8, 8, 'F');
    doc.setTextColor.apply(doc, ink); doc.setFont('helvetica', 'bold'); doc.setFontSize(13);
    doc.text('Total (incl. assembly & testing)', 58, y + 33);
    doc.setTextColor.apply(doc, purple); doc.setFontSize(20);
    doc.text(money(totalCents), 537, y + 35, { align: 'right' });

    y += 90;
    doc.setTextColor.apply(doc, grey); doc.setFont('helvetica', 'normal'); doc.setFontSize(9.5);
    doc.text('Quote generated ' + new Date().toLocaleDateString() + '  ·  Valid 14 days  ·  Our team will contact you about this build', 40, y);
    /* store details straight from Shopify settings; wraps if long */
    var footerLines = doc.splitTextToSize(root.dataset.pdfFooter || 'Tech Store', 515);
    doc.text(footerLines, 40, y + 16);

    doc.save('techstore-pc-quote.pdf');
  }

  function boot() {
    document.querySelectorAll('[data-ts-build]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
